import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../services/Spinner.service';
import { FormGroup, FormControl, Validators, FormBuilder ,AbstractControl} from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { LocalStorage } from '../../services/local-storage';
import { PasswordValidation } from '../shared/components/password-validation';
import { ControlMessagesComponent } from '../shared/components/control-messages.component';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../shared/components/popupAdmin/popup-segment.component';

@Component({

  selector: 'app-updatepassword',
  templateUrl: './updatepassword.component.html',
 // styleUrls: ['./updatepassword.component.css'],
  providers :[LocalStorage,SharedService,PopupSegmentComponent]
})
export class UpdatePasswordComponent implements OnInit {
objLoaderStatus: boolean = false;
  passwordreset: string;
  newpasswordreset: string;
  confirmpasswordreset: string;
  changeForm: FormGroup;
  successMsg : boolean;
  errorMsg : string;

  constructor(private localstorage : LocalStorage,private formBuilder: FormBuilder, private router: Router,private shareService :SharedService, private loaderService: LoaderService,private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) { 
  }
  ngOnInit() {
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
    let body = document.getElementsByTagName('body')[0];
   body.classList.remove("zizbackground");
         body.classList.remove("overflow");

    this.successMsg=false;
    this.errorMsg='';
    this.changeForm = this.formBuilder.group({
      password: ['', Validators.compose([ValidationService.requiredpassValidator])],
      newpassword: ['', Validators.compose([ValidationService.passwordValidator])],
      confirmpassword: ['', Validators.required],
      deviceToken: ["AQDX124324"],
      loginFlg: ['false']
    }, {
      validator: PasswordValidation.MatchPassword // your validation method
    });
  }
  private customValidator(control) {         
    //console.log(this.registerForm.value.password)
    var flag={isEqual: control.value === this.changeForm.value.password}
     console.log(flag);
     return true;
  }
  onSubmit() {
    this.loaderService.displayLoader(true);
      
     this.changeForm.value.confirmPass=this.changeForm.value.confirmpassword;
     var changeData = {
                  "confirmPass": this.changeForm.value.confirmpassword,
                  "newPass": this.changeForm.value.newpassword,
                  "oldPass": this.changeForm.value.password,
              }
        var token=this.localstorage.getStorage('token');
       this.shareService.callApiWithToken("admin/changeAdminPassword",changeData,token).subscribe((result) => {
          if(result.data) {
            this.localstorage.setStorage('token',result.data.token);
           this.successMsg=true;
         this.showUpdate();
           this.successMsg=false;
        
                  
                  this.loaderService.displayLoader(false);
          }
          else {
             this.errorMsg = 'Current password you entered is incorrect';
            
            this.loaderService.displayLoader(false);
          }
     
     

          
    });
}

  showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Account Information', 
                message:"Password has been updated Successfully",
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
            this.router.navigate(['admin/users']);
                });
        }

}



// WEBPACK FOOTER //
// ./src/app/admin/updatepassword/updatepassword.component.ts